
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-music-generator",
      function () {
        return require("private-next-pages/ai-music-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-music-generator"])
      });
    }
  